import axios from "../common";

export const ApiDashboardList = async () => {
    let url = '/dashboards/list'
    return await axios.get(url, {withCredentials: true})
}

export const ApiFetchDashboard = async (dashboardId: number) => {
    let url = `/dashboards/detail/${dashboardId}`
    return await axios.get(url, {withCredentials: true})
}